export default __webpack_public_path__ + "static/media/capsule.e4ef3c28.png";